import { methodSteps } from '@/mocks/site';

export default function MethodSection() {
  return (
    <section id="method" className="w-full bg-foreground-950 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl">
          <p className="font-label text-xs tracking-[0.25em] text-accent-400 mb-3">
            HOW WE VERIFY / 核对流程
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-tight">
            从片尾一行字，到一页可检索的档案
          </h2>
          <p className="mt-4 text-sm md:text-base text-background-300/85 leading-relaxed">
            每条档案都按同一套流程走一遍。流程公开，是为了让你知道我们的结论是从哪一步推出来的，也方便你复核。
          </p>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-px bg-background-50/10 rounded-lg overflow-hidden">
          {methodSteps.map((step) => (
            <div
              key={step.no}
              className="relative bg-foreground-950 p-5 md:p-6 hover:bg-primary-950 transition-colors"
            >
              <span className="font-label text-3xl md:text-4xl font-medium text-primary-500/70">
                {step.no}
              </span>
              <h3 className="mt-3 font-heading text-base md:text-lg font-bold text-background-50">
                {step.title}
              </h3>
              <p className="mt-2.5 text-xs md:text-sm text-background-300/80 leading-relaxed">
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}